package com.vizio.redwolf.pay.client

import com.vizio.redwolf.pay.model.OfferDetailsByOfferIdRequestInfo
import com.vizio.redwolf.pay.model.OfferIdByLinkingPinClientRequestInfo
import com.vizio.redwolf.utils.AppConfig
import com.vizio.redwolf.utils.CONTENT_TYPE_APP_JSON_UTF8
import com.vizio.redwolf.utils.ClientConfig
import com.vizio.redwolf.utils.HttpResult
import com.vizio.redwolf.utils.OffersEnvironment
import com.vizio.redwolf.utils.applyAppConfig
import com.vizio.redwolf.utils.applyTimeout
import com.vizio.redwolf.utils.applyUserBearerToken
import com.vizio.redwolf.utils.buildHttpRequest
import com.vizio.redwolf.utils.safeHttpCall
import com.vizio.redwolf.utils.setTraceId
import io.ktor.client.HttpClient
import io.ktor.client.request.HttpRequestBuilder
import io.ktor.client.request.headers
import io.ktor.client.request.parameter
import io.ktor.client.request.request
import io.ktor.client.request.setBody
import io.ktor.client.statement.HttpResponse
import io.ktor.http.HttpHeaders
import io.ktor.http.HttpMethod
import io.ktor.http.URLProtocol
import io.ktor.http.path
import kotlinx.serialization.json.Json
import kotlinx.serialization.json.encodeToJsonElement

class OffersHttpClient(
    private val environment: OffersEnvironment,
    private val appConfig: AppConfig,
    private val clientConfig: ClientConfig
) :
    OffersClient {

    private val httpClient: HttpClient = clientConfig.clientProvider.httpClient
    private val identityProxyEnv = environment.identityEnv
    private val json = Json { encodeDefaults = true }

    override suspend fun requestOfferDetailsByOfferId(requestInfo: OfferDetailsByOfferIdRequestInfo, traceId: String?): HttpResult<HttpResponse> {
        val httpRequestBuilder = HttpRequestBuilder().apply {
            url {
                protocol = URLProtocol.HTTPS
                host = identityProxyEnv.host
                path("${identityProxyEnv.rewardsPath}/tv-link/complete/offers/${requestInfo.offerId}")
            }
            headers {
                append(HttpHeaders.ContentType, CONTENT_TYPE_APP_JSON_UTF8)
            }
            parameter(PARAMETER_LINKING_PIN, requestInfo.pin)
            applyAppConfig(appConfig)
            applyUserBearerToken(requestInfo.accessToken)
            setTraceId(traceId)
            applyTimeout(clientConfig.timeout)
            method = HttpMethod.Get
        }
        return safeHttpCall(httpRequestInfo = httpRequestBuilder.buildHttpRequest()) {
            httpClient.request(httpRequestBuilder)
        }
    }

    override suspend fun requestOfferIdByLinkingPin(m2mToken: String, requestInfo: OfferIdByLinkingPinClientRequestInfo, traceId: String?): HttpResult<HttpResponse> {
        val requestBody = json.encodeToJsonElement(requestInfo)
        val httpRequestBuilder = HttpRequestBuilder().apply {
            url {
                protocol = URLProtocol.HTTPS
                host = identityProxyEnv.host
                path("${identityProxyEnv.rewardsPath}/tv-link/requested/offers")
            }
            headers {
                append(HttpHeaders.ContentType, CONTENT_TYPE_APP_JSON_UTF8)
            }
            setBody(requestBody)
            applyAppConfig(appConfig)
            applyUserBearerToken(m2mToken)
            setTraceId(traceId)
            applyTimeout(clientConfig.timeout)
            method = HttpMethod.Post
        }
        return safeHttpCall(httpRequestInfo = httpRequestBuilder.buildHttpRequest()) {
            httpClient.request(httpRequestBuilder)
        }
    }

    companion object {
        private const val PARAMETER_LINKING_PIN = "pin"
    }
}